module.exports = __webpack_public_path__ + "images/sensei-55372725b6d56ef084da8f3bc5e2b24e.png";